import ApiRoute from '../api/ApiRoute';
import Urls from '../api/Configuration';
import ApplicationResponse from '../api/dtos/application/ApplicationResponse';
import ApplicationsResponse from '../api/dtos/application/ApplicationsResponse';
import ApplicationVersionsResponse from '../api/dtos/application/ApplicationVersionsResponse';
import { UpdateApplicationRequest } from '../api/dtos/application/UpdateApplicationRequest';
import EmptyApiResponse from '../api/dtos/EmptyApiResponse';
import ServiceLocator from './ServiceLocator';

export default class ApplicationService {
    public GetApplications(): Promise<ApplicationsResponse> {
        return ServiceLocator.ApiClient.Get<ApplicationsResponse>(Urls.ADMIN_APPLICATIONS);
    }

    public UpdateApplication(applicationId: number, request: UpdateApplicationRequest): Promise<ApplicationResponse> {
        return ServiceLocator.ApiClient.Patch<ApplicationResponse>(ApiRoute.Create(Urls.ADMIN_UPDATE_DELETE_APPLICATION)
            .WithParameter('applicationId', applicationId)
            .AsUrl(), request);
    }

    public GetApplicationVersions(applicationId: number): Promise<ApplicationVersionsResponse> {
        return ServiceLocator.ApiClient.Get<ApplicationVersionsResponse>(ApiRoute.Create(Urls.ADMIN_APPLICATION_VERSIONS)
            .WithParameter('applicationId', applicationId)
            .AsUrl());
    }

    public DeployApplication(applicationId: number, version: string): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Patch<EmptyApiResponse>(ApiRoute.Create(Urls.ADMIN_APPLICATION_DEPLOY)
            .WithParameter('applicationId', applicationId)
            .AsUrl(), { version });
    }

    public RemoveApplication(applicationId: number): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Delete<EmptyApiResponse>(ApiRoute.Create(Urls.ADMIN_UPDATE_DELETE_APPLICATION)
            .WithParameter('applicationId', applicationId)
            .AsUrl(), null);
    }

}